import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-primary min-h-[60vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 py-16 lg:py-24 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="text-white">
            <div className="inline-flex items-center gap-2 bg-accent/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <Icon name="Award" size={20} />
              <span className="text-sm font-semibold font-accent">30+ Years Commercial Excellence</span>
            </div>

            <h1 className="font-headline font-bold text-4xl md:text-5xl lg:text-6xl mb-6 leading-tight">
              Trusted by Major Brands Across South Africa
            </h1>

            <p className="text-lg md:text-xl mb-8 text-white/90 font-body leading-relaxed">
              From McDonald's kitchens to KFC installations, we deliver enterprise-grade plumbing and electrical solutions that keep major commercial operations running flawlessly.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:0827935785"
                className="inline-flex items-center justify-center gap-3 bg-accent text-accent-foreground px-8 py-4 rounded-lg font-semibold text-lg hover:bg-accent/90 transition-all emergency-cta">

                <Icon name="Phone" size={24} />
                <span className="font-accent">082 793 5785</span>
              </a>
              <a
                href="#portfolio"
                className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/20 transition-all">

                <span>View Projects</span>
                <Icon name="ArrowDown" size={20} />
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <Image
                src="https://img.rocket.new/generatedImages/rocket_gen_img_111ebf809-1766756813446.png"
                alt="Professional commercial plumber in blue uniform installing industrial grade stainless steel piping system in modern commercial kitchen with bright overhead lighting"
                className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent"></div>
            </div>

            <div className="absolute -bottom-6 -left-6 bg-card rounded-xl shadow-elevated p-6 max-w-xs">
              <div className="flex items-center gap-4">
                <div className="bg-success/10 p-3 rounded-lg">
                  <Icon name="CheckCircle2" size={32} color="var(--color-success)" />
                </div>
                <div>
                  <p className="font-headline font-bold text-2xl text-foreground">500+</p>
                  <p className="text-muted-foreground text-sm font-body">Commercial Projects</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;